export default __webpack_public_path__ + "static/media/morphy.02668542.txt";